
import Vue from 'vue'
import InputSummary from './InputSummary/Index.vue'
import AccountType from './AccountTypeButtonSelector.vue'
import OrderType from './OrderType.vue'
import BillingAddress from './Address/BillingAddressType.vue'
import DeliveryMethod from './Address/DeliveryMethod.vue'
import DigitalDelivery from './Address/DigitalDelivery.vue'
import PaymentMethod from './Payment/PaymentMethod.vue'
import { Step } from '../../store'

export default Vue.extend({
   name: 'InputSection',
   computed: {
      step(): Step {
         return this.$store.state.step
      },
      viewedSteps(): Step[] {
         return this.$store.state.viewedSteps
      },
      hasviewedSteps(): boolean {
         return this.viewedSteps.length > 0
      },
      showInformationStep(): boolean {
         return this.step === 'information'
      },
      showOrderTypeStep(): boolean {
         return this.step === 'order_type'
      },
      showShippingStep(): boolean {
         return this.step === 'shipping' && this.$store.getters.requiresDelivery
      },
      showBillingStep(): boolean {
         return (
            this.$store.state.requiresBillingAddress &&
            this.step === 'payment' &&
            this.$store.state.purchase.IsPersonalOrder
         )
      },
      showPaymentStep(): boolean {
         return this.step === 'payment'
      },
   },
   components: {
      InputSummary,
      AccountType,
      OrderType,
      BillingAddress,
      DeliveryMethod,
      DigitalDelivery,
      PaymentMethod,
   },
})
